import React, { useState, createRef } from "react";
import Field from "./Shared/Field";
import Input from "./Shared/Input";
const NumberInput = (props) => {
    const { label, readOnly = false, inline = false, value, onChange, error, autoComplete = "off", override = {}, } = props;
    const hasValue = Boolean(value);
    const [isFocused, setFocuse] = useState(false);
    const inputRef = createRef();
    const hasError = Boolean(error);
    return (React.createElement(Field, { label: props.label, readOnly: props.readOnly, open: props.open, inline: props.inline, hasValue: hasValue, info: props.info, error: props.error, isFocused: isFocused, autoComplete: props.autoComplete, onClick: props.onClick, onFocus: props.onFocus, onBlur: props.onBlur, override: props.override, onLabelClick: () => {
            if (inputRef && inputRef.current)
                inputRef.current.focus();
        } },
        React.createElement(Input, { label: label, readOnly: readOnly, inline: inline, value: value, autoComplete: autoComplete, onChange: (value) => {
                if (readOnly || !onChange)
                    return;
                else if (value === "" || typeof value === "undefined")
                    onChange();
                else if (typeof value === "string" && !Number.isNaN(Number(value)))
                    onChange(Number(value));
                else if (typeof value === "number" && !Number.isNaN(value))
                    onChange(value);
            }, type: "text", setFocus: setFocuse, hasError: hasError, rows: 0, onClick: props.onClick, onFocus: props.onFocus, onBlur: props.onBlur, suggestions: props.suggestions, onSuggestionSelect: props.onSuggestionSelect, inputRef: inputRef, override: override })));
};
export default NumberInput;
